<template>
    <b-container id="registration-customer-sign-up">
        <div v-if="!completed">
            <h4>{{ env.COMPANY_APP_INITIAL }} Wholesale - Sign Up</h4>
            <hr>
            <b-form @submit.prevent="submit">
                <b-form-row>
                    <b-col class="customer-sign-up-left-col">
                        <b-form-group id="input-group-company-name" label="Company / Store Name:" label-for="input-company-name" label-size="sm">
                            <b-form-input id="input-company-name" v-model="formData.companyName" type="text" autocomplete="off" size="sm" placeholder="" required />
                        </b-form-group>
                        <b-form-group id="input-group-resellers-permit" label="Business Resellers Permit #:" label-for="input-resellers-permit" label-size="sm">
                            <b-form-input id="input-resellers-permit" v-model="formData.resellersPermit" type="text" autocomplete="off" size="sm" placeholder="" required />
                        </b-form-group>
                        <b-form-group id="input-group-phone" label="Business Phone Number:" label-for="input-phone" label-size="sm">
                            <b-form-input id="input-phone" v-model="formData.phone" type="text" autocomplete="off" size="sm" placeholder="" required />
                        </b-form-group>
                        <b-form-group id="input-group-buyers-name" label="Buyers Name:" label-for="input-buyers-name" label-size="sm">
                            <b-form-input id="input-buyers-name" v-model="formData.buyersName" type="text" autocomplete="off" size="sm" placeholder="" required />
                        </b-form-group>
                        <b-form-group id="input-group-buyers-contact-number" label="Buyers Contact Number:" label-for="input-buyers-contact-number" label-size="sm">
                            <b-form-input id="input-buyers-contact-number" v-model="formData.mobile" type="text" autocomplete="off" size="sm" placeholder="" required />
                        </b-form-group>
                        <b-form-group id="input-group-email" label="E-mail:" label-for="input-email" label-size="sm">
                            <b-form-input id="input-email" v-model="formData.email" type="text" autocomplete="off" size="sm" placeholder="" required />
                        </b-form-group>
                    </b-col>
                    <b-col class="customer-sign-up-right-col">
                        <b-form-group id="input-group-address-line-1" label="Address:" label-size="sm" label-for="input-address-line-1" description="Address Line 1">
                            <b-form-input id="input-address-line-1" v-model="formData.address.line1" type="text" autocomplete="off" size="sm" required />
                        </b-form-group>
                        <b-form-group id="input-group-address-line-2" description="Address Line 2">
                            <b-form-input id="input-address-line-2" v-model="formData.address.line2" type="text" autocomplete="off" size="sm" />
                        </b-form-group>
                        <b-form-row>
                            <b-col>
                                <b-form-group id="input-group-address-city" description="City">
                                    <b-form-input id="input-address-city" v-model="formData.address.city" type="text" autocomplete="off" size="sm" required />
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group id="input-group-address-state" description="State / Province / Region">
                                    <b-form-input id="input-address-state" v-model="formData.address.state" type="text" autocomplete="off" size="sm" required />
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col>
                                <b-form-group id="input-group-address-zip" description="Zip / Postal Code">
                                    <b-form-input id="input-address-zip" v-model="formData.address.zip" type="text" autocomplete="off" size="sm" required />
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group id="input-group-address-country" description="Country">
                                    <b-form-select v-model="formData.address.country" id="countrySelect" size="sm" value-field="country_code" text-field="country_name" :options="countries" />
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <hr>
                        <b-form-group id="input-group-username" label="Username:" label-for="input-username" label-size="sm">
                            <b-form-input id="input-username" v-model="formData.username" type="text" autocomplete="off" size="sm" placeholder="" required />
                        </b-form-group>
                        <b-form-group id="input-group-password" label="Password:" label-for="input-password" label-size="sm">
                            <b-form-input id="input-password" v-model="formData.password" type="password" autocomplete="off" size="sm" placeholder="" required />
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-button type="submit" variant="success" class="btn-sm">
                    <span v-if="submitting">
                        <b-spinner small type="grow"></b-spinner>
                        Submitting...
                    </span>
                    <span v-else>Submit</span>
                </b-button>
            </b-form>
        </div>
        <div v-else class="sign-up-confirmation">
            <p>Application Submitted Successfully</p>
            <p>We will review your application and notify you via e-mail once completed.</p>
            <p>If you need immediate assistance please call</p>
            <p>877-803-7549</p>
            <p>Thank you</p>
            <p>Black Sheep Gallery</p>
        </div>

        <modal-duplicate-found
            v-if="modals['modal-registration-customer-sign-up-duplicate-found'].active"
        />
    </b-container>
</template>

<script>
    import ModalDuplicateFound from './modals/DuplicateFound'
    export default {
        name: 'CustomerSignUp',

        components: {
            'modal-duplicate-found': ModalDuplicateFound
        },

        data() {
            return {
                modals: {
                    'modal-registration-customer-sign-up-duplicate-found': {
                        active: 0
                    }
                },
                countries: [],
                formData: {
                    address: {
                        country: 'US'
                    }
                },
                submitting: 0,
                completed: 0
            }
        },

        methods: {
            openModal(modalName, row) {
                switch (modalName) {
                    case 'modal-registration-customer-sign-up-duplicate-found':

                        break
                }

                this.modals[modalName].active = 1

                this.$nextTick(() => {
                    this.$bvModal.show(modalName)
                })
            },

            submit() {
                this.submitting = 1
                let formData = this.formData

                let url = 'api/lists/customersignup/submitrequest'
                axios.post(url, {
                    formData
                })
                .then((res) => {
                    this.submitting = 0

                    let status = res.data.status
                    if (status == 'success') {
                        this.completed = 1
                    } else if (status == 'exists') {
                        this.openModal('modal-registration-customer-sign-up-duplicate-found')
                    } else {
                        this.showAlertBox('error', 'Error', 'There was an error submitting your form. Please try again.')
                    }
                }, () => {
                    this.has_error = true
                })
            },

            getCountries() {
                let url = 'api/locations/getcountries'
                axios.get(url, {})
                .then((res) => {
                    this.countries = res.data.countries
                }, () => {
                    this.has_error = true
                })
            }
        },

        mounted() {
            this.getCountries()
        }
    }
</script>

<style lang="scss">
    #registration-customer-sign-up {
        margin-top: -40px;
        width: 50%;
        max-width: 800px;

        .customer-sign-up-left-col {
            border-right: 1px rgba(0, 0, 0, 0.1) solid;
            padding-right: 20px;
        }

        .customer-sign-up-right-col {
            padding-left: 20px;
        }
    }

    .sign-up-confirmation {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
    }
</style>
